<template>
  <router-view/>
</template>

<script>
export default {
    name: 'Configuracao'
}
</script>

<style scoped>

</style>